import { showLoadingRecovery } from './loading-recovery.js';
import { reportError, errorStep } from "./posthog.js";
import { initializeImageFormat } from "./image-format.js";
import { preferredLocale, translator } from "./i18n.js";
let saved = {};
try {
  saved = JSON.parse(localStorage.getItem("runmarco-reimagined-v1") || "{}");
} catch {}
const locale = preferredLocale(
  saved && typeof saved === "object" ? saved : {},
  navigator.language,
);
const t = translator(locale);
document.documentElement.lang = locale;
document.title = t("title");
if (document.getElementById("boot-message")) document.getElementById("boot-message").textContent = t("loadingAdventure");
document
  .getElementById("boot-progress")
  ?.setAttribute("aria-label", t("loadingAdventure"));
const failed = error => {
  reportError(error, 'bootstrap');
  console.error(error);
  const message = document.getElementById('boot-message');
  if (message) message.textContent = t('loadError');
  showLoadingRecovery(document, { message: t('loadError'), label: t('retryLoading'),
    retry: () => location.reload() });
};
window.addEventListener('vite:preloadError', event => {
  // The rejected import is handled below; do not suppress it and continue boot.
  failed(event.payload);
});
// Choose image URLs before rendering markup or creating Phaser textures.
errorStep('bootstrap_started');
initializeImageFormat()
  .then(() => import("./main.js"))
  .catch(failed);
